module.exports = __webpack_public_path__ + "img/william-lloyd-garrison.de93f116.png";